export default "__VITE_ASSET__BOvn7BNs__"